<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: AssetColumnSelector.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="assets__column-selector">
    <tree-view class="assets__column-selector" :model="filters" category="children" :selection="value"
      :onSelect="onSelect" :strategies="strategies" :transition="transition"></tree-view>
  </div>
</template>

<script>
import { TreeView } from '@bosket/vue'

export default {
  name: 'AssetColumnSelector',
  components: {
    TreeView,
  },
  props: {
    filters: Array,
    value: Array,
  },
  computed: {
    strategies() {
      return {
        selection: ['multiple'],
        click: ['select'],
      }
    },
    transition() {
      return {
        props: {
          name: 'tree-trans',
        },
      }
    },
  },
  methods: {
    onSelect(newSelection) {
      this.$emit('input', newSelection)
    },
  },
  mounted() {
    console.log('FILTERS', this.value)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
// @import "~@/styles/theme";
@import "~@/styles/globals";

.assets__column-selector {

  /* Elements */
  ul {
    list-style-type: none;
    padding-left: 2em;

    &.depth-0 {
      padding: 0;
    }
  }

  ul:not(.depth-0)>li {
    .item {
      transition: all 0.3s;
      border-left: 4px solid $black-45;
    }
  }

  ul>li>span.item {
    display: block;
    padding: 0.3em;

    &:hover {
      cursor: pointer;
      background-color: $light;
    }

    span {
      vertical-align: middle;
    }
  }

  /* Root list */
  ul.depth-0 {}

  /* Not disabled */
  ul li:not(.disabled) {}

  ul li:not(.disabled)>span.item {}

  /* Selected */
  ul li.selected {
    .item {
      border-left: 4px solid $blue-dark;
    }

    .label {
      color: $blue-dark;
    }
  }

  ul li.selected>span.item {}

  /* Categories : Nodes with children */
  ul li.category {}

  ul li.category>span.item {}

  /* Folded */
  ul li.category.folded {}

  ul li.category.folded>span.item {}

  /* Unfolded */
  ul li.category:not(.folded) {}

  ul li.category:not(.folded)>span.item {}

  ul li.category:not(.folded)>span.item>.opener {
    transform: rotate(90deg);
  }

  /* Opener */
  ul li.category>span.item>.opener {
    transition: all 0.3s;
    color: $secondary;
  }

  ul li.category>span.item>.opener::after {
    content: "\e910";
  }

  /* Folded async */
  li.category.async {}

  li.category.async>span.item {}

  /* Loading async */
  li.category.loading {}

  li.category.loading>span.item {}

  /* Animations on component creation / destruction */
  .tree-trans-enter,
  .tree-trans-leave-to {
    max-height: 0px;
    transform: scaleY(0);
    transform-origin: top;
  }

  .tree-trans-enter-to,
  .tree-trans-leave {
    max-height: 500px;
  }

  .tree-trans-enter-active {
    transition: all 0.3s ease-in;
  }

  .tree-trans-leave-active {
    transition: all 0.3s ease-out;
  }

  /* Drag'n'drop */
  ul.dragover {}

  li.dragover {}

  li.dragover>span.item {}

  li.nodrop {}

  li.nodrop>span.item {}
}

.assets__filter-extra-list {
  padding: 0;
  list-style-type: none;
}
</style>
